<section class="sidebar open" [class.open]="classOpen">
    <button class="bt-minimizar" (click)="showHideBoxMainEditRoute()">
        <i class="fa fa-chevron-left" [class.fa-chevron-left]="classPullRight" [class.fa-chevron-right]="classPullDown"></i>
    </button>
    <div class="blocos-info"> 
        <box-title *ngIf="roteiro.roteiroLimpo" 
        titulo="Roteiro com informações reduzidas. As informações de coleta de GPS, histórico de ações e traçado não estão mais disponíveis para consulta." 
        mostraAviso="true" 
        color="#FFF3EB">
           
        </box-title> 
        <box-title titulo="Informações gerais" color="white" [btnConfiguracao]="true" (minimizeMobile)="showHideBoxMainEditRoute()">
            <box-info-truck [dados]="roteiro" [roteiroCrossdocking]="roteiroCrossdocking"></box-info-truck>
        </box-title> 
        <box-title titulo="Jornada" color="white" (minimizeMobile)="showHideBoxMainEditRoute()">
            <box-info-journey [dados]="roteiro"></box-info-journey>
        </box-title>
        <box-title [titulo]="roteiroCrossdocking ? 'Detalhes do Crossdocking' : 'Detalhes do Roteiro'" color="white">
          <box-info-delivery-router [dados]="roteiro" [roteiroCrossdocking]="roteiroCrossdocking"></box-info-delivery-router>
        </box-title>
        <box-title [titulo]="'Ocorrências (' + (boxInfoAlertService?.alertRouter?.length ?? '0') + ')'" color="white" [hidden]='!routeService.exibeAlerta'> 
            <box-info-alert></box-info-alert>
        </box-title>
        <box-title [titulo]="'Alertas do Mapa (' + (alertasCardService?.qtdAlertas ?? '0') + ')'"  color="white" class="hide-on-mobile"> 
          <app-alerta-roteiro-notificacao [dados]="roteiro"></app-alerta-roteiro-notificacao>
        </box-title>
        <box-title titulo="Roteiros ({{roteiro.roteirosCrossdocking.length}})" color="white" *ngIf="roteiroCrossdocking"> 
          <box-roteiros-crossdocking [dados]="roteiro"></box-roteiros-crossdocking>
        </box-title>
        <box-title titulo="Configurações de entrega/roteiro" 
        
            color="#2C3136"
            textColor="#F6F6F8"
            [btnClose]='true'
            [shadow]='true'
            *ngIf="this.graphicService.mostraConfiguracaoRoteiro" class="modal-conf">
          <app-config-confirmacao-entrega [dados]="roteiro" 
       ></app-config-confirmacao-entrega>
        </box-title>

        <box-title titulo="Roteiro" color="white" [hidden]="roteiroCrossdocking">
            <box-info-router [dados]="roteiro" ></box-info-router>
        </box-title>
        <box-title titulo="Histórico de Ações" color="white">
            <box-historico-acoes [roteiro]="roteiro" [roteiroCrossdocking]="roteiroCrossdocking"></box-historico-acoes>
        </box-title>
    </div>
    <div class="mobile-fixed-map-footer hide-on-desktop" (click)="showHideBoxMainEditRoute()">
      <button class="btn-mobile-ver-mapa">
        <img src="assets/img/icons/icon-abrir-map-green.svg" class="map-icon-white" alt="Ver mapa">
        <span>Ver mapa</span>
      </button>
    </div>
</section>